module.exports = __webpack_public_path__ + "flyer_background_palms_001-77a06d526448a808bed1eccc2ca56d91.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_palms_001.jpg
// module id = 1670
// module chunks = 1